import { LoginHubResendConfirmationMailAction } from './login-hub-resend-confirmation-mail';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export type LoginHubResendConfirmationMailErrorAction = LoginHubResendConfirmationMailAction;

const successLoginHubResendConfirmationMailMock: LoginHubResendConfirmationMailAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
	});
};

const failMock: LoginHubResendConfirmationMailErrorAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
	});
};

export const loginHubResendConfirmationMailMocks: {
	successLoginHubResendConfirmationMail: LoginHubResendConfirmationMailAction;
	failError: LoginHubResendConfirmationMailErrorAction;
} = {
	successLoginHubResendConfirmationMail: successLoginHubResendConfirmationMailMock,
	failError: failMock
};
